import { Injectable } from '@angular/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { ValidationService } from '@app/shared/services/validation.service'
import { OpportunityAgreement } from '@app/modules/opportunity-agreement/opportunity-agreement.model'
import { Person } from '@app/modules/person/person.model'
import { PersonFormService } from '@app/modules/person/person-form.service'

@Injectable()

export class OpportunityAgreementFormService {

  /**
   * Insert vaildators
   */
  public insertValidators: Array<any> = [
    {
      agreementUuid: [
        ValidationService.isUuid
      ]
    },
    {
      opportunityUuid: [
        ValidationService.isUuid
      ]
    },
    {
      signedByPersonUuid: [
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Update validators
   */
  public updateValidators: Array<any> = [
    {
      uuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Constructor
   */
  public constructor (
    private formBuilder: FormBuilder,
    public validationService: ValidationService,
    private personFormService: PersonFormService
  ) {}

  /**
   * Get form
   */
  public getForm (opportunityAgreement: OpportunityAgreement, type: string): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      uuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      agreementUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      opportunityUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      sent: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      received: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      signedByPersonUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      // Info.
      createdAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      updatedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      deletedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      createdByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      updatedByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ]
    })

    if (type === 'new') {
      this.validationService.addInsertValidators(form, this.insertValidators)
    }

    if (type === 'edit') {
      this.validationService.addUpdateValidators(form, this.insertValidators, this.updateValidators)
    }

    if (opportunityAgreement.signedByPerson) {
      const signedByPerson: Person = new Person()
      form.addControl('signedByPerson', this.personFormService.getForm(signedByPerson, ''))
    }

    if (opportunityAgreement) {
      form.patchValue(opportunityAgreement, { emitEvent: false })
    }

    return form
  }

}
